import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PartDescription as BomPartDescription } from 'bom/components';
import { BomPartType } from 'bom/enums';
import { IQuotePart } from 'quotes/types';

import { PartDescriptionTypeDiscount } from './PartDescriptionTypeDiscount';

interface IProps {
  quotePart: IQuotePart;
}

export const PartDescription = ({ quotePart }: IProps) => {
  const { t } = useTranslation();

  const extra = useMemo(() => {
    if (!quotePart.corporatePartConfig?.isBaseCodePart) {
      return null;
    }

    return t('labelBaseCode');
  }, [quotePart.corporatePartConfig?.isBaseCodePart, t]);

  const getDescription = () => {
    switch (quotePart.type) {
      case BomPartType.PART:
      case BomPartType.COMPONENT:
        return <BomPartDescription bomPart={quotePart} extra={extra} />;
      case BomPartType.DISCOUNT:
        return <PartDescriptionTypeDiscount quotePart={quotePart} />;
      default:
        return;
    }
  };

  return getDescription();
};
